<div class="overlay" (click)="onBackdropClick($event)">
  <div class="viewer" role="dialog" aria-modal="true" aria-labelledby="guide-viewer-title">
    @if (guide.type === 'video' && guide.video; as video) {
      <div class="v-top">
        <span class="vt" id="guide-viewer-title">{{ guide.title }}</span>
        <span class="vc">{{
          video.durationSec
            ? ('GuidesVideoDuration' | translate: { duration: formatDuration(video.durationSec) })
            : ('GuidesVideo' | translate)
        }}</span>
        @if (guide.allowSkip) {
          <button type="button" class="v-x" [attr.aria-label]="'GuidesClose' | translate" (click)="close()">×</button>
        }
      </div>
      <div class="v-stage video">
        @if (videoFailed) {
          <div class="v-empty">{{ 'GuidesVideoError' | translate }}</div>
        } @else {
          <video
            controls
            playsinline
            preload="metadata"
            [src]="video.url"
            [attr.poster]="video.thumbnailUrl || null"
            (ended)="videoEnded = true"
            (error)="videoFailed = true"></video>
        }
      </div>
      <div class="v-text">
        <h3>{{ guide.title }}</h3>
        <p>{{ video.summary || guide.description }}</p>
      </div>
      <div class="v-foot">
        <span class="v-dots"></span>
        <button #nextBtn type="button" class="vbtn next" (click)="completed.emit()">
          {{ (videoEnded ? 'GuidesFinish' : 'GuidesWatched') | translate }}
        </button>
      </div>
    } @else if (step) {
      <div class="v-top">
        <span class="vt" id="guide-viewer-title">{{ guide.title }}</span>
        <span class="vc">{{ 'GuidesStepOf' | translate: { current: index + 1, total: steps.length } }}</span>
        @if (guide.allowSkip) {
          <button type="button" class="v-x" [attr.aria-label]="'GuidesClose' | translate" (click)="close()">×</button>
        }
      </div>
      <div class="v-stage" (pointerdown)="onPointerDown($event)" (pointerup)="onPointerUp($event)">
        @if (imageFailed) {
          <div class="v-empty">{{ 'GuidesImageError' | translate }}</div>
        } @else {
          <!-- Keyed on the index so each step's image re-mounts and replays the fade-in. -->
          @for (current of [step]; track index) {
            <img [src]="current.imageUrl" [alt]="current.title" draggable="false" (error)="imageFailed = true" />
          }
        }
        @if (index > 0) {
          <button type="button" class="v-arrow l" [attr.aria-label]="'GuidesPrevStep' | translate" (click)="back()">
            <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M10 3 5 8l5 5" /></svg>
          </button>
        }
        @if (!isLast) {
          <button type="button" class="v-arrow r" [attr.aria-label]="'GuidesNextStep' | translate" (click)="next()">
            <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="m6 3 5 5-5 5" /></svg>
          </button>
        }
      </div>
      <div class="v-text">
        <span class="vs">{{ 'GuidesStepLabel' | translate: { number: index + 1 } }}</span>
        <h3>{{ step.title }}</h3>
        <p>{{ step.description }}</p>
      </div>
      <div class="v-foot">
        <div class="v-dots">
          @for (s of steps; track s.order; let k = $index) {
            <button
              type="button"
              [class.on]="k === index"
              [class.seen]="k < index"
              [attr.aria-label]="'GuidesGoToStep' | translate: { number: k + 1 }"
              (click)="goTo(k)"></button>
          }
        </div>
        @if (guide.allowSkip && !isLast) {
          <button type="button" class="vbtn skip" (click)="close('skipped')">{{ 'GuidesSkip' | translate }}</button>
        }
        <button type="button" class="vbtn back" [disabled]="index === 0" (click)="back()">{{ 'GuidesBack' | translate }}</button>
        <button #nextBtn type="button" class="vbtn next" (click)="next()">
          {{ (isLast ? 'GuidesFinish' : 'GuidesNext') | translate }}
        </button>
      </div>
    }
  </div>
</div>
